import {
  GET_SECTIONS_SUCCESS,
  GET_SECTIONS_FAILURE,
} from '../../../../config/constants/ActionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case GET_SECTIONS_SUCCESS: {
      return {
        ...state,
        sections: action.payload.sections,
      }
    }

    case GET_SECTIONS_FAILURE: {
      return {
        ...state,
        getSectionsError: action.payload.error,
      }
    }

    default:
      return state
  }
}
